import React, { memo, useCallback, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import Link from 'next/link';

import interactionResponse from 'await-interaction-response';

import { useFeatures } from '@atc/features';

import { sendClick } from 'reaxl-analytics';

import getPathSRP from '@/utilities/getPathSRP';

import { viewNationwideInventoryClick } from '@/analytics/srp/srpSearchEvents';

import queryDuck from '@/ducks/queryDuck';
import srpPaginationDuck from '@/ducks/srp/srpPaginationDuck.js';
import srpResultsDuck from '@/ducks/srp/srpResultsDuck.js';

function MaxResultsButtonContainer() {
    const {
        default_num_records: [, { num_records: numRecordsSortOptions }],
    } = useFeatures([
        'default_num_records',
    ]);
    const currentPage = useSelector(srpPaginationDuck.selectors.getCurrentPage);
    const numRecords = useSelector(srpPaginationDuck.selectors.getNumRecords);
    const query = useSelector(queryDuck.selectors.getDuckState);
    const maxResultCount = useSelector(srpResultsDuck.selectors.getMaxActiveResultsCount);
    const resultCount = useSelector(srpResultsDuck.selectors.getResultsCount);

    const numRecordsData = { ...numRecordsSortOptions, value: numRecords };

    const [nationwideLink, setNationwideLink] = useState('');

    const handleNationwideClick = async (event) => {
        await interactionResponse();
        sendClick(viewNationwideInventoryClick, event);
    };
    const getNationwideLink = useCallback(async () => {
        const nationwideQuery = { ...query };
        delete nationwideQuery.zip;
        delete nationwideQuery.city;
        delete nationwideQuery.state;
        const path = await getPathSRP({ ...nationwideQuery, searchRadius: '0' }, { basePath: false });
        setNationwideLink(path);
    }, [query]);

    useEffect(() => {
        getNationwideLink();
    }, [getNationwideLink]);

    const itemsPerPageMax = (numRecordsData?.value) || 25;

    const getNumbThru = () => {
        let numthru = Math.abs(Number.isInteger(currentPage) ? currentPage : 1) * itemsPerPageMax || itemsPerPageMax;

        if (numthru >= resultCount || numthru < itemsPerPageMax) {
            numthru = resultCount;
        }
        return numthru;
    };

    if (maxResultCount && getNumbThru() >= maxResultCount) {
        return (
            <div
                className="text-center margin-top-5 margin-bottom-5"
                data-cmp="max-results-message"
            >
                You have reached the maximum results allowed for a search. Please update your search criteria.
                <div>
                    <Link
                        href={nationwideLink}
                        onClick={handleNationwideClick}
                    >
                        View Nationwide Inventory
                    </Link>
                </div>
            </div>
        );
    }
}

export default memo(MaxResultsButtonContainer);
